// extracted by mini-css-extract-plugin
module.exports = {"region-select":"_2yU63EfzZ7","number":"_2Zcz4tYKpJ","icon-down":"_2SImbB1IJ0"};